import { NgClass, NgFor, NgIf } from '@angular/common'
import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { AbstractDialogComponent } from '../dialog.class'
import { ButtonData } from '../dialog.models'

export type ConfirmDialogData =
    | {
          title: string
          message: string
          messages?: undefined
          cancelButton?: ButtonData
          hideCancelButton?: boolean
          confirmButton: ButtonData
      }
    | {
          title: string
          message?: undefined
          messages: string[]
          cancelButton?: ButtonData
          hideCancelButton?: boolean
          confirmButton: ButtonData
      }

export type ConfirmDialogResponse = boolean

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatDialogModule, NgClass, NgFor, NgIf],
})
export class ConfirmDialogComponent extends AbstractDialogComponent<ConfirmDialogData, ConfirmDialogComponent> implements AfterViewInit {
    cancelButton: ButtonData
    confirmButton: ButtonData

    @ViewChild('confirm', { static: true }) confirmButtonElement: MatButton | undefined

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
        public dialogRef: MatDialogRef<ConfirmDialogComponent>
    ) {
        super(data, dialogRef)

        this.cancelButton = this.getCancelButtonData()
        this.confirmButton = this.getConfirmButtonData()
    }

    ngAfterViewInit() {
        if (this.confirmButtonElement) {
            this.confirmButtonElement._elementRef.nativeElement.focus()
        }
    }

    get dialogTitle() {
        return this.data.title
    }

    get dialogMessages() {
        return this.data.message ? [this.data.message] : this.data.messages
    }

    get isCancelButtonHidden(): boolean {
        return this.data.hideCancelButton === true
    }

    private getCancelButtonData(): ButtonData {
        const cancelButtonDefault: ButtonData = {
            label: 'Cancel',
        }

        if (this.data.cancelButton) {
            return Object.assign(cancelButtonDefault, this.data.cancelButton)
        }

        return cancelButtonDefault
    }

    private getConfirmButtonData(): ButtonData {
        const confirmButtonDefault: Partial<ButtonData> = {
            color: 'primary',
        }

        return Object.assign(confirmButtonDefault, this.data.confirmButton)
    }
}
